export const isValidEmail = (email) => {
  return (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email));
}

export const isBrowser = typeof window !== "undefined";
